import { BaseState } from '@/store/base-state';
import { PaginationProps, TableOptions } from '@/types';
import { default_project, default_new_project, default_catalog_products_filters } from '@/modules/projects/services';
import { Clients } from '@/modules/clients/types';
import { Projects, ProjectsFilters } from '../types';

export default class ProjectsState extends BaseState {
  projects: Projects.Project[] = [];
  current_project: Projects.Project = default_project();
  new_project: Projects.NewProject = default_new_project();
  products: Projects.AddProduct[] = [];
  equipments: Projects.Equipments[] = [];
  competitors: Projects.Competitors[] = [];

  clients_for_project: Clients.ClientToAddItem[] = [];

  projects_loading = false;

  filters: ProjectsFilters = {
    search: '',
    created_at: '',
    closed_at: '',
    organization_ids: '',
    statuses: null,
    partner_contact_persons: null,
  };

  partner_contact_persons: string[] = [];
  organizations: string[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['created_at'],
    sortDesc: [true],
  };

  catalog_products_loading = false;

  catalog_products: Projects.CatalogProduct[] = [];

  catalog_products_filters: Projects.CatalogProductRequestFilters = default_catalog_products_filters();

  catalog_products_pagination_props: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  catalog_products_table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['product_code'],
    sortDesc: [true],
  }
}
